import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api/lines`,
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000
});

export const getLines = async () => {
  const response = await api.get('/');
  return response.data;
};

export const createLine = async (lineData) => {
  const response = await api.post('/', lineData);
  return response.data;
};

export const updateLine = async (lineId, lineData) => {
  const response = await api.put(`/${lineId}`, lineData);
  return response.data;
};

export const deleteLine = async (lineId) => {
  const response = await api.delete(`/${lineId}`);
  return response.data;
};

export const getLineById = async (lineId) => {
  const response = await api.get(`/${lineId}`);
  return response.data;
};

export const getLinesByLayout = async (layoutId) => {
  const response = await api.get(`/layout/${layoutId}`);
  return response.data;
};

export const updateLineStatus = async (lineId, statusData) => {
  const response = await api.put(`/${lineId}/status`, statusData);
  return response.data;
};

export const updateLineDevices = async (lineId, deviceIds) => {
  const response = await api.put(`/${lineId}/devices`, { deviceIds });
  return response.data;
};

export const setAllLinesToBlinking = async (layoutId) => {
  const response = await api.put(`/layout/${layoutId}/blinking`);
  return response.data;
};

export const getLayoutCycle = async (layoutId) => {
  const response = await api.get(`/layout/${layoutId}/cycle`);
  return response.data;
};

export const getLinePhase = async (lineId) => {
  const response = await api.get(`/${lineId}/phase`);
  return response.data;
};

export const changeActiveLine = async (lineId) => {
  const response = await api.put(`/${lineId}/active`);
  return response.data;
};
